export const languageStorageKey = 'HIGO-language';

export const saveLocalLanguage = (code: string) => {
  localStorage.setItem(languageStorageKey, code);
};
export const readLocalLanguage = () => localStorage.getItem(languageStorageKey);
